'use client';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { SM_BREAKPOINT } from '@/lib/constants';
import { useGSAP } from '@gsap/react';

const useInitAnimation = () => {
  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('.fade-up').forEach(el => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: el,
            start: window.innerWidth < SM_BREAKPOINT ? 'top bottom' : 'top 80%',
            end: window.innerWidth < SM_BREAKPOINT ? 'bottom bottom' : 'bottom+=20% 80%',
            markers: false,
            toggleActions: 'play none none reverse',
          },
        })
        .from([el.querySelector('p'), el.querySelector('h5')], {
          y: 50,
          opacity: 0,
          duration: 0.5,
          ease: 'power3.inOut',
          stagger: 0.1,
        });
    });

    document.querySelectorAll('.ani-up').forEach(el => {
      const animationUp = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: window.innerWidth < SM_BREAKPOINT ? 'top bottom' : 'top 80%',
          end: window.innerWidth < SM_BREAKPOINT ? 'top+=30% bottom' : 'bottom+=20% 80%',
          markers: false,
          toggleActions: 'play none none reverse',
        },
      });

      animationUp.fromTo(el, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 0.5, ease: 'power3.inOut' });
    });
  });
};

export const UpAnimations = () => {
  useInitAnimation();
  return <></>;
};
export default UpAnimations;
